import { CardContent, TextField } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import CardTitle from "@saleor/components/CardTitle";
import ControlledCheckbox from "@saleor/components/ControlledCheckbox";
import FormSpacer from "@saleor/components/FormSpacer";
import { SubscriptionErrorFragment } from "@saleor/fragments/types/SubscriptionErrorFragment";
import { commonMessages } from "@saleor/intl";
import { getFormErrors } from "@saleor/utils/errors";
import getSubscriptionErrorMessage from "@saleor/utils/errors/subscriber";
import React from "react";
import { useIntl } from "react-intl";

import { SubscriberPageFormData } from "../SubscriberPage/SubscriberPage";
export interface SubscriberDetailsProps {
  data: SubscriberPageFormData;
  disabled: boolean;
  errors: SubscriptionErrorFragment[];
  onChange: (event: React.ChangeEvent<any>) => void;
  title: string;
}
const SubscriberDetails: React.FC<SubscriberDetailsProps> = ({
  data,
  disabled,
  errors,
  onChange
}) => {
  const intl = useIntl();

  const formErrors = getFormErrors(["email", "active"], errors);
  return (
    <Card>
      <CardTitle
        title={intl.formatMessage(commonMessages.generalInformations)}
      />
      <CardContent>
        <TextField
          disabled={disabled}
          label={intl.formatMessage({
            defaultMessage: "Email Of Subscriber",
            description: "the email text of the subscriber"
          })}
          error={!!formErrors.email}
          name={"email" as keyof SubscriberPageFormData}
          fullWidth
          helperText={getSubscriptionErrorMessage(formErrors.email, intl)}
          value={data.email}
          onChange={onChange}
        />
        <FormSpacer />
        <ControlledCheckbox
          name={"active" as keyof SubscriberPageFormData}
          label={intl.formatMessage({
            defaultMessage: "Subscribed",
            description: "check to require active to have value"
          })}
          checked={data.active}
          onChange={onChange}
          disabled={disabled}
        />
      </CardContent>
    </Card>
  );
};
export default SubscriberDetails;
